import type { CanvasLayout } from "@/types";

/**
 * A service's saved builder-canvas position, or null when it has none.
 *
 * The backend seeds a never-arranged service with {0,0}; that reads as "not placed yet" so the canvas
 * falls back to auto-layout for it rather than pinning it to the origin. Both the editor canvas (from a
 * `Service`) and the history canvas (from a `ServiceHistory`) apply this rule, so it lives in one place —
 * either carries the position under `canvasLayout`.
 */
export function storedCanvasPosition(
  service: { canvasLayout?: CanvasLayout }
): { x: number; y: number } | null {
  const layout = service.canvasLayout;
  if (!layout) return null;
  if (layout.x === 0 && layout.y === 0) return null;
  return { x: layout.x, y: layout.y };
}
